import _DialogContent from "@mui/material/DialogContent";
import _Box from "@mui/material/Box";
import _Typography from "@mui/material/Typography";
import _Dialog2 from "@mui/material/Dialog";
import _Button2 from "@mui/material/Button";
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import BfgScoreFormula from './bfg-score-formula';
import CustomPointsRules from './custom-points-rules';
function CustomPointsDialogButton({
  Button: _Button,
  Dialog: _Dialog,
  eventCode,
  metricsWeights,
  onFaqClick,
  progressWeightingMode
}) {
  const [open, setOpen] = useState(false);
  const {
    t
  } = useTranslation();
  const Button = _Button || _Button2;
  const Dialog = _Dialog || _Dialog2;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
    color: "primary",
    onClick: () => onFaqClick ? onFaqClick() : setOpen(true),
    size: "small",
    sx: {
      fontSize: 14,
      fontWeight: 700,
      lineHeight: 1.15,
      paddingLeft: 0,
      textTransform: 'none'
    },
    variant: "text"
  }, t('commons.challenges.custom_faq.title')), /*#__PURE__*/React.createElement(Dialog, {
    fullWidth: true,
    maxWidth: "sm",
    onClose: () => setOpen(false),
    open: open
  }, /*#__PURE__*/React.createElement(_DialogContent, {
    sx: _Dialog ? {
      padding: 0
    } : {}
  }, /*#__PURE__*/React.createElement(_Box, {
    display: "flex",
    flexDirection: "column",
    gap: 3
  }, /*#__PURE__*/React.createElement(_Typography, {
    fontSize: "1.25rem",
    fontWeight: 600
  }, t('commons.challenges.custom_faq.title')), /*#__PURE__*/React.createElement(CustomPointsRules, {
    eventCode: eventCode,
    metricsWeights: metricsWeights
  }), progressWeightingMode === 'EMPLOYEE_RATIO' && /*#__PURE__*/React.createElement(BfgScoreFormula, null), /*#__PURE__*/React.createElement(_Box, {
    display: "flex",
    justifyContent: "flex-end"
  }, /*#__PURE__*/React.createElement(Button, {
    color: "primary",
    onClick: () => setOpen(false),
    variant: "contained"
  }, t('commons.actions.understood')))))));
}
export default CustomPointsDialogButton;